/* InviteClinician auto-generated by npm run generator */
import { Button, Checkbox, Dialog, FormControlLabel, TextField } from "@material-ui/core"
import { PortalRole } from "@qlarity/common"
import { CloseButton } from "components/atoms/CloseButton"
import { observable } from "mobx"
import { observer } from "mobx-react"
import React from "react"
import { useParams } from "react-router-dom"
import Store from "store/Store"
import PortalForm, { PortalSubmitButton } from "../PortalForm"
class InviteClinicianState {
    @observable
    componentName = "InviteClinician"

    @observable
    isInviteOpen = false

    @observable
    displayName = ""

    @observable
    email = ""

    @observable
    role = PortalRole.CLINICIAN
}

const InviteClinician: React.FC = () => {
    const state = React.useRef(new InviteClinicianState()).current
    const { orgId } = useParams()

    if (!orgId) {
        return null
    }

    const toggleInviteClician = () => {
        state.email = ""
        state.displayName = ""
        state.isInviteOpen = !state.isInviteOpen
    }

    const handleAdminCheckbox = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        state.role = checked ? PortalRole.ORG_ADMIN : PortalRole.CLINICIAN
    }

    const invitePortalUser = async () => {
        const { success } = await Store.auth.invitePortalUser(state.email, orgId, state.role, state.displayName)
        if (success) {
            toggleInviteClician()
        }
    }

    return (
        <>
            <Button onClick={toggleInviteClician} color="secondary">
                Invite Clinician
            </Button>
            <Dialog open={state.isInviteOpen} onClose={toggleInviteClician}>
                <PortalForm
                    closeButton={<CloseButton onClick={toggleInviteClician} />}
                    title="Send Clinician Invite"
                    subtitle="This will send an invitation to your clinician"
                    form={
                        <>
                            <TextField label="Name" value={state.displayName} onChange={(e) => (state.displayName = e.target.value)} required />
                            <TextField label="Email" type="email" value={state.email} onChange={(e) => (state.email = e.target.value)} required />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={state.role === PortalRole.ORG_ADMIN}
                                        color={state.role === PortalRole.ORG_ADMIN ? "primary" : "default"}
                                        onChange={handleAdminCheckbox}
                                        name="isOrgAdmin"
                                    />
                                }
                                label="Make org admin"
                            />
                        </>
                    }
                    buttons={<PortalSubmitButton>Send Invitation</PortalSubmitButton>}
                    buttonAction={invitePortalUser}
                />
            </Dialog>
        </>
    )
}

export default observer(InviteClinician)
